import addStartupScript from './events/addStartupScript';
import forEachSelector from './elements/forEachSelector';

function setupFadeBlock(expandMoreButton) {
  const textContent = expandMoreButton.previousElementSibling;
  const mobileDevice = window.matchMedia('only screen and (max-width: 480px)').matches;
  const minContentHeight = mobileDevice ? 240 : 160;

  if(textContent.scrollHeight > minContentHeight) {
    setupButton(expandMoreButton);
  } else {
    textContent.classList.remove('fade-overlay');
    expandMoreButton.style.display = 'none';
  }
}

function setupButton(expandMoreButton) {
  const button = expandMoreButton.querySelector('.link');

  button.addEventListener('click', function (e) {
    const textContent = expandMoreButton.previousElementSibling;

    textContent.classList.toggle('expand-text');

    if(textContent.classList.contains('expand-text')) {
      button.innerHTML = button.dataset.expandedText;
    } else {
      button.innerHTML = button.dataset.collapsedText;
    }
  });
}

export function setup() {
  forEachSelector('.block--fade-expand-more', setupFadeBlock);
}

addStartupScript(setup);
